import NetworkSpeed from 'network-speed'; // ES5

export async function getNetworkDownloadSpeed(): Promise<string> {
  const testNetworkSpeed = new NetworkSpeed();
  const baseUrl = '/-/media/Default Website/cover.ashx';
  const fileSizeInBytes = 119719;
  const speed = await testNetworkSpeed.checkDownloadSpeed(baseUrl, fileSizeInBytes);
  return speed.mbps;
}
